<div class="big-card-header">
  <div class="icon-square"><mat-icon>group</mat-icon></div>
  <div class="big-card-title">
    <div class="title-line">
      <div class="name">{{ name }}</div>
      @if (canEdit) {
        <button mat-icon-button class="pencil" (click)="edit.emit()" aria-label="Edit team">
          <mat-icon>edit</mat-icon>
        </button>
      }
    </div>
    <div class="meta-line">
      @if (membersCount !== null) {
        <span>{{ membersCount }} members</span>
      }
      @if (membersCount !== null) {
        <span aria-hidden="true">•</span>
      }
      <span><strong>{{ amount | currency:'USD':'symbol':'1.0-2' }}</strong> /month per employee</span>
      @if (canEdit) {
        <button mat-icon-button class="pencil" (click)="edit.emit()" aria-label="Edit benefit amount">
          <mat-icon>edit</mat-icon>
        </button>
      }
    </div>
  </div>
</div>
